(ns ^:dev/always rothko.icon.core
  (:require-macros [rothko.cljstemplates :refer [deftmpl]]))

(deftmpl svg-icons-html "svg-icons.html")
